import { Link, useParams } from 'react-router-dom'
import Breadcrumb from '../components/Breadcrumb'
import { maruzalar } from '../utils/Data'
import { useState } from 'react';
import HTMLReactParser from 'html-react-parser/lib/index';
import Test from '../utils/Test';

function MaruzaDetails() {
    const { id } = useParams()
    const [tab, setTab] = useState('texts');
    const [quizNumber, setQuizNumber] = useState(0);
    const [quizLength, setQuizLength] = useState(0);
    return (
        <>
            <Breadcrumb text="Ma'ruzalar" subText={maruzalar[id - 1]?.title} route='/maruza' routeID={id} />
            <section className="my-120 @">
                <div className="container-lg">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="courses-details-left-content">
                                <div className="top-content">
                                    <div className="courses-img">
                                        <img src={maruzalar[id - 1]?.image} alt={maruzalar[id - 1]?.title} />
                                    </div>
                                    <h3 className="title text-center">{maruzalar[id - 1]?.title}</h3>
                                </div>
                                <div className="middle-content">
                                    <nav>
                                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                            <button
                                                onClick={() => setTab('texts')}
                                                className="nav-link active" id="nav-overview-tab" data-bs-toggle="tab" data-bs-target="#nav-overview" type="button" role="tab" aria-controls="nav-overview" aria-selected="true">
                                                Ma'lumot
                                            </button>
                                            <button
                                                onClick={() => setTab('tasks')}
                                                className="nav-link" id="nav-curriculum-tab" data-bs-toggle="tab" data-bs-target="#nav-curriculum" type="button" role="tab" aria-controls="nav-curriculum" aria-selected="false" tabIndex="-1">
                                                Topshiriq
                                            </button>
                                            <button
                                                onClick={() => setTab('author')}
                                                className="nav-link" id="nav-instructor-tab" data-bs-toggle="tab" data-bs-target="#nav-instructor" type="button" role="tab" aria-controls="nav-instructor" aria-selected="false" tabIndex="-1">
                                                Muallif
                                            </button>
                                        </div>
                                    </nav>
                                    <div className="tab-content" id="nav-tabContent">
                                        <div className={`tab-pane fade ${tab === 'texts' ? 'show active' : ''}`} id="nav-overview" role="tabpanel" aria-labelledby="nav-overview-tab">
                                            <div className="overview-content">
                                                {
                                                    HTMLReactParser(maruzalar[id - 1]?.text)
                                                }
                                            </div>
                                        </div>
                                        <div className={`tab-pane fade ${tab === 'tasks' ? 'show active' : ''}`} id="nav-curriculum" role="tabpanel" aria-labelledby="nav-curriculum-tab">
                                            <h4 className="title">Topshiriq</h4>
                                            <div className="service-cards">
                                                <div className="card-content">
                                                    <Test setQuizNumber={setQuizNumber} setQuizLength={setQuizLength} quizName={'test1'} questionsData={maruzalar[id - 1]?.quizzes} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`tab-pane fade ${tab === 'author' ? 'show active' : ''}`} id="nav-instructor" role="tabpanel" aria-labelledby="nav-instructor-tab">
                                            <div className="instructor-content">
                                                <div className="instructor-left-content">
                                                    <div className="left-content-img">
                                                        <img height='auto' src="/assets/images/author.jpg" alt="Xudayberdiyev Abdumadjid" />
                                                    </div>
                                                    <ul className="instructor-social-link">
                                                        <li>
                                                            <a href="#"><i className="my-icon icon-facebook"></i></a>
                                                        </li>
                                                        <li>
                                                            <a href="#"><i className="my-icon icon-instagram"></i></a>
                                                        </li>
                                                        <li>
                                                            <a href="#"><i className="my-icon icon-youtube"></i></a>
                                                        </li>
                                                        <li>
                                                            <a href="#"><i className="fab fa-telegram"></i></a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="instructor-right-content">
                                                    <h3 className="title">Xudoyberdiyev Abdumadjid</h3>
                                                    <p className="tag">O'qituvchi</p>
                                                    <p className="para">
                                                        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Impedit, praesentium. Eius reiciendis veritatis suscipit? Est odit optio repudiandae ut totam? <br />
                                                        <br />
                                                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste mollitia quas, hic harum eius tempore adipisci culpa labore.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="courses-details-right-content">
                                <div className="side-bar-top-content">
                                    <h3 className="courses-features">Mundarija</h3>
                                    <ul className="courses-details-list">
                                        {
                                            maruzalar.map(maruza => {
                                                return <li key={maruza.id}>
                                                    <div className="list-left-content">
                                                        <div className="list-icon">
                                                            <i className="my-icon icon-lesson"></i>
                                                        </div>
                                                        <Link to={`/maruza/${maruza?.id}`} className="para">
                                                            {maruza.title.length > 31 ? maruza.title.slice(0, 31) + '...' : maruza.title}
                                                        </Link>
                                                    </div>
                                                    <p className="para"> {maruza.id}</p>
                                                </li>
                                            })
                                        }
                                    </ul>
                                    <ul className="courses-list-btn">
                                        <li className='w-100'>
                                            <Link to='/maruza'> <i className="fas fa-list-ul"></i> Barcha ma'ruzalar</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        </>
    )
}

export default MaruzaDetails